import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const ClosingMessageTab = observer(() => {
  return (
    <div className={styles.tabContent}>
      <Typography ariaLabel={'closingMessage'} variant={'body-rg-medium'}>
        Closing message
      </Typography>
    </div>
  )
})
